module.exports = __webpack_public_path__ + "static/media/image_3.fc47d249.png";